import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faNewspaper } from '@fortawesome/free-regular-svg-icons'
import '../../helpers/font-awesome'
import { useGlobalData } from '../../context/globalDataContxt';
import NoveltyCard from '../NoveltyCard/NoveltyCard'
import './NoticesAndNovelties.scss'

const NoticesAndNovelties = ({
  novelties,
  title,
  latest,
}) => {

  const noveltiesLimit = 3;

  const { noveltiesAll } = useGlobalData();

  // Creando Array de todas las noticias que se deben mostrar con sus respectivos campos
  let noveltyAll = novelties.reduce((acc, noveltie) => {
    for (const nov in noveltiesAll) {
      const novelty = noveltiesAll[nov]
      if (noveltie.novelty?.id === novelty.id) {
        acc.push(noveltyConstructor(novelty, noveltie.destacado));
      }
    }
    return acc;
  }, [])

  // Armando el array con las noticias más recientes
  const noveltiesLatest = noveltiesAll?.map((novelty) => {
    return noveltyConstructor(novelty);
  })

  // En caso de estar el bool Latest activado, se muestran las noticias más recientes, de lo contrario, se muestran las noticias seleccionadas
  noveltyAll = latest === true 
    ? noveltiesLatest.slice(0, noveltiesLimit) 
    : noveltyAll

  return noveltyAll && noveltyAll.length ? (
    <div className="mb-1 container">
      {/* Title */}
      <div className="mb-3 novelties-title-container">        
        <div className={`mb-0 novelties-title`}>
          <FontAwesomeIcon icon={faNewspaper} className="me-2" />
          {title ? title : 'NOTICIAS'}
        </div>
        
        <Link
          to={'/noticias'}
          className={`cards-section-button rounded-pill px-3`}
        >
          Ver todas
        </Link>
      </div>

      {/* Preview de las Novelties */}
      <div className="row novelty-container">
        {noveltyAll?.map((noveltie, i) => {
          if (
            noveltie?.novelty.slug &&
            (noveltie?.novelty.dateTo === null ||
              moment(noveltie.novelty.dateTo, 'YYYY/MM/DD').isSameOrAfter(moment())
            )
          ) {
            return (
              <div
                  className={`col-12 col-md-6 col-lg-4`}
                  key={`noveltiesNodesId-${noveltie.novelty.id}`}
                >
                  <NoveltyCard key={noveltie?.novelty.id} noveltie={noveltie} />
              </div>
            )
          }
          return null
        })}
      </div>
    </div>
  ) : null
}

// Construyendo estructura de las Noticias
const noveltyConstructor = (novelty, destacado = false) => {
  return ({
    id: novelty.id,
    destacado: destacado,
    novelty: {
      id: novelty.id,
      slug: novelty.slug,
      title: novelty.title,
      thumbnailName: novelty.thumbnailName,
      thumbnail: { url: novelty.thumbnail?.url },
      date: novelty.date,
      dateTo: novelty.dateTo,
      novelties_categories: novelty.novelties_categories?.map((categories) => categories.id),
      summary: novelty.summary
    }
  })
}

export default NoticesAndNovelties

NoticesAndNovelties.propTypes = {
  novelties: PropTypes.array.isRequired,
  title: PropTypes.string,
  latest: PropTypes.bool,
}
